'use client';

import { clearInstantRouteTransition } from '@/components/InstantRouteTransitionOverlay';
import { GTMEventType } from '@/lib/GTMEventType';
import { sendGTMEvent } from '@/lib/gtm-wrapper';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export default function NotFoundTracker() {
  const pathname = usePathname();

  useEffect(() => {
    // Soft-nav overlay must clear on 404 (esp. /bolge/* where pathname alone does not clear).
    clearInstantRouteTransition();
    sendGTMEvent({
      event: GTMEventType.EXCEPTION,
      page_url: pathname || '',
      error_type: '404 Error',
      fatal: false,
    });
  }, [pathname]);

  return null;
}
